<script lang="ts">
  import { Image } from "sveltestrap";
  import { Postreat } from "../../../../utils/Constant/Constant";
  import UserPostComment from "./UserPostComment.svelte";
  let imgPath:string = "/assets/images/user";
  export let people: number;
  export let likes: number;
  export let comments: number;
  export let shares: number;
</script>

<div class="post-react">
  <ul>
    <li><Image class="rounded-circle" src="{imgPath}/3.jpg" alt="" /></li>
    <li><Image class="rounded-circle" src="{imgPath}/5.jpg" alt="" /></li>
    <li><Image class="rounded-circle" src="{imgPath}/1.jpg" alt="" /></li>
  </ul>
  <h6>+{people} {'people react this post'}</h6>
</div>
<p>{Postreat}</p>
<UserPostComment likes={likes} comments={comments} shares={shares}/>
